// Dependencies
import React, { Suspense, lazy, useContext } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import DesktopLayout from "../components/DesktopLayout";
import MobileLayout from "../components/MobileLayout";
import UserContext from "../context/User/UserContext";
import { configApp } from "../configApp";
import { isMobileOnly } from "react-device-detect";

// Components
const Login = lazy(() => import("../components/Login"));
const NotPermissions = lazy(() => import("../components/NotPermissions"));

const AppRouter = () => {
  const { user } = useContext(UserContext);
  const isAuth = Boolean(user);

  const routes = configApp.map(({ path, component, exact, permissions }) => {
    return {
      path,
      component:
        user && permissions.includes(user.codPermiso)
          ? component
          : NotPermissions,
      exact,
    };
  });

  return (
    <Router>
      {isAuth ? (
        isMobileOnly ? (
          <MobileLayout>
            <div>Hola</div>
          </MobileLayout>
        ) : (
          <DesktopLayout>
            <Suspense fallback={<div>Cargando...</div>}>
              <Switch>
                {routes.map(({ ...route }, i) => (
                  <Route key={i} {...route} />
                ))}
                <Redirect push to="/app" />
              </Switch>
            </Suspense>
          </DesktopLayout>
        )
      ) : (
        <Suspense fallback={<div>Cargando...</div>}>
          <Switch>
            <Route exact path="/login" component={Login} />
            <Redirect push to="/login" />
          </Switch>
        </Suspense>
      )}
    </Router>
  );
};

export default AppRouter;
